import { render } from "./AppAuthConsent.vue?vue&type=template&id=6c04acb7"
import script from "./AppAuthConsent.vue?vue&type=script&lang=js"
export * from "./AppAuthConsent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/AppAuthConsent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c04acb7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c04acb7', __exports__)) {
    api.reload('6c04acb7', __exports__)
  }
  
  module.hot.accept("./AppAuthConsent.vue?vue&type=template&id=6c04acb7", () => {
    api.rerender('6c04acb7', render)
  })

}


export default __exports__